import React, { useContext } from 'react';
import SectionTitle from '../../property-partners-portal/components/SectionTitle/SectionTitle';
import NonEditionContent from './NonEditionContent';
import EditionContent from './EditionContent';
import { ContextSettings } from '../../contexts/SettingsContext';
import Clock from './Clock';
import CardPlaceholder from '../components/CardPlaceholder';
import GoBackHomeLink from '../GoBackHomeLink';

const SettingsContainer = () => {
    const { isEditionMode, isLoading } = useContext(ContextSettings);
    return (
        <div className='settings__container'>
            <div className='page-title__container'>
                <SectionTitle title='settings' />
                <GoBackHomeLink loading={isLoading} />
            </div>
            <Clock />
            {isLoading ? (
                <CardPlaceholder />
            ) : (
                <div className='card'>
                    {isEditionMode ? <EditionContent /> : <NonEditionContent />}
                </div>
            )}
        </div>
    );
};

export default SettingsContainer;
